<app-top-nav></app-top-nav>

<div class="main">
  <div
    class="d-flex flex-column bg-light contentContainer"
    style="height: 100vh; padding-top: 150px; padding-left: 8%"
  >
    <div>
      <div class="pl-1 mb-5">
        <p i18n="@@admin.verify.mft">Verify MFT connection</p>
      </div>
      <div class="d-flex flex-row mb-5">
        <div class="p-2">
          <span class="label" i18n="@@admin.verify.mft.type">Type</span>
          <div class="input-container">
            <input type="text" placeholder="Name" [(ngModel)]="typeMFT" />
          </div>
        </div>
      </div>
      <div d-flex flex-row class="csv-buttons my-auto">
        <button
          class="trigger text-uppercase mr-2"
          [disabled]="!typeMFT"
          [ngClass]="{ 'button-inactive': !typeMFT }"
          (click)="sendMftTestTrigger()"
          i18n="@@admin.verify.mft.action"
        >
          Send command to test connection
        </button>
      </div>
    </div>

    <div class="mt-2">
      <div class="pl-1 mb-5">
        <p i18n="@@admin.verify.b2b">Verify B2B connection</p>
      </div>
      <div class="d-flex flex-row mb-5">
        <div class="p-2">
          <span class="label" i18n="@@admin.verify.b2b.type">Type</span>
          <div class="input-container">
            <input type="text" placeholder="Name" [(ngModel)]="typeB2B" />
          </div>
        </div>

        <div class="p-2">
          <span class="label" i18n="@@admin.verify.b2b.key">Key</span>
          <div class="input-container">
            <input type="text" placeholder="Name" [(ngModel)]="keyB2B" />
          </div>
        </div>
      </div>
      <div d-flex flex-row class="csv-buttons my-auto">
        <button
          class="trigger text-uppercase mr-2"
          [disabled]="!typeB2B || !keyB2B"
          [ngClass]="{ 'button-inactive': !typeB2B || !keyB2B }"
          (click)="sendB2BTestTrigger()"
          i18n="@@admin.verify.b2b.action"
        >
          Send command to test connection
        </button>
      </div>
    </div>
  </div>
</div>
